var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Field } from "formik";
import TagSelect from "@codex/components/TagSelect";
export var FormikTagField = function (_a) {
    var name = _a.name, validate = _a.validate, onChange = _a.onChange, question = _a.question, restProps = __rest(_a, ["name", "validate", "onChange", "question"]);
    return (React.createElement(Field, { name: name, validate: validate }, function (_a) {
        var value = _a.field.value, _b = _a.form, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
        return (React.createElement(React.Fragment, null,
            React.createElement(TagSelect, __assign({ onChange: function (value) {
                    setFieldValue(name, value);
                    onChange && onChange(value);
                }, 
                // onBlur={value => {
                //     setFieldTouched(name)
                //     onBlur && onBlur(value)
                // }}
                question: question }, restProps))));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/TagInput/TagInput.tsx
// module id = 1484
// module chunks = 0